/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_AllInputs */

const en_admin_categories_all = /** @type {(inputs: Admin_Categories_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Categories`)
};

/**
* | output |
* | --- |
* | "All Categories" |
*
* @param {Admin_Categories_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_categories_all = /** @type {((inputs?: Admin_Categories_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_categories_all(inputs)
});
export { admin_categories_all as "admin.categories.all" }